module.exports = __webpack_public_path__ + "img/3x.ec12b93.jpg";